import React from "react";
import history from "./history";
import { removeAll, removeAssured } from "./../Store/data/actions";
import { useDispatch } from "react-redux";
import { addRecommended } from "../Store/recommended/actions";
import Arrow from "../Resources/svg/simulate.svg";

const BackButton = (props) => {
  const className = props.className || "";
  const path = props.path;
  const dispatch = useDispatch();
  const goBack = function (e, path) {
    if (path === undefined) {
      history.goBack();
      dispatch(addRecommended({}));
      dispatch(removeAll());
      dispatch(removeAssured());
    } else if (typeof path === "function") {
      path();
    } else {
      history.go(path);
    }
  };

  return (
    <button
      onClick={(e) => goBack(e, path)}
      className={`back-button ${className}`}
      type="button"
    >
      <img src={Arrow} alt="Arrow" />
      <span className="back__span">Regresar</span>
    </button>
  );
};

export default BackButton;
